const icon = "/_app/immutable/assets/icon.gHcCChSy.ico";
export {
  icon as default
};
